
const ivr= {
  state: {
    editShow :false,
    nameShow:true,
    ivrId:0,
    followOrder:1,
    id:0,  //主键id
  },
  mutations: {
    SET_EDIT_SHOW:(state,bool)=>{
      state.editShow = bool;
    },
    SET_NAME_SHOW:(state,show)=>{
      state.nameShow = show;
    },
    SET_IVR_ID:(state,ivrId)=>{
      state.ivrId = ivrId;
    },
    SET_FollowOrder:(state,order)=>{
      state.followOrder = order;
    },
    SetId(state, id) {
      state.id = id;
    }
  },
  actions: {
    setEditShow({ commit }, bool) {
      commit("SET_EDIT_SHOW", bool);
    },
    setIvrId({ commit }, ivrId) {
      commit("SET_IVR_ID", ivrId);
    },
    setNameShow({ commit }, show) {
      commit("SET_NAME_SHOW", show);
    },
    setFollowOrder({ commit }, order) {
      commit("SET_FollowOrder", order);
    },
    setId({ commit }, id) {
      commit("SetId", id);
    }
  } 
};
export default ivr;

